import type { WorkspaceOpenIMClient } from './openim-types';

const WEB_PLATFORM_ID = 5;
const SILENT_LOG_LEVEL = 5;

/** createWorkspaceOpenIMClient 懒加载固定版本 SDK，并封装 P0 只读所需的最小接口。 */
export async function createWorkspaceOpenIMClient(): Promise<WorkspaceOpenIMClient> {
  if (import.meta.env.DEV && import.meta.env.VITE_OPENIM_CLIENT_MODE === 'mock') {
    const { createWorkspaceOpenIMMockClient } = await import('./openim-client.mock');
    return createWorkspaceOpenIMMockClient();
  }
  const { getSDK } = await import('@openim/client-sdk');
  const sdk = getSDK();
  return {
    createTextMessage: async content => (await sdk.createTextMessage(content)).data,
    getConversations: async () => (
      await sdk.getConversationListSplit({ count: 100, offset: 0 })
    ).data,
    getHistory: async (conversationID, startClientMsgID) => (
      await sdk.getAdvancedHistoryMessageList({
        conversationID,
        count: 50,
        startClientMsgID,
        viewType: 0,
      })
    ).data,
    getUsersInfo: async userIDs => (await sdk.getUsersInfo(userIDs)).data,
    isJoinGroup: async groupID => (await sdk.isJoinGroup(groupID)).data,
    joinGroup: async (params) => {
      await sdk.joinGroup({
        groupID: params.groupID,
        joinSource: params.joinSource ?? 3,
        reqMsg: params.reqMsg ?? '',
      });
    },
    login: async (params) => {
      await sdk.login({
        ...params,
        logLevel: SILENT_LOG_LEVEL,
        platformID: WEB_PLATFORM_ID,
      });
    },
    logout: async () => {
      await sdk.logout();
    },
    markConversationRead: async (conversationID) => {
      await sdk.markConversationMessageAsRead(conversationID);
    },
    off: (event, handler) => {
      sdk.off(event as never, handler as never);
    },
    on: (event, handler) => {
      sdk.on(event as never, handler as never);
    },
    sendMessage: async params => (await sdk.sendMessage({
      groupID: params.groupID ?? '',
      message: params.message as never,
      recvID: params.recvID ?? '',
    })).data,
  };
}
